import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type React from 'react';
import FanTokens2 from './assets/fanTokens2.png';
import Gem from './assets/Gem.png';
import Poe2 from './assets/poe2.png';
export const AuthBackground = t0 => {
  const $ = _c(13);
  const {
    className
  } = t0;
  const t1 = `bg-auth-background relative flex h-[100vh] w-[100vw] overflow-hidden ${className ?? ""}`;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={Poe2} alt="Poe" className="Poe1 absolute left-[22%] top-[8%] w-[90px] tablet:left-[-0.8%] tablet:top-[18%] tablet:w-[140px]" />;
    t3 = <Image src={FanTokens2} alt="FanTokens" className="Fan1 absolute  left-[36%] top-[11%] w-[40px] tablet:left-[2%]  tablet:top-[17%] tablet:w-[87px]" />;
    t4 = <Image src={Poe2} alt="Poe" className="Poe2 absolute bottom-[-2.2%] left-[28%] hidden h-[109px] w-[109px] tablet:block " />;
    t5 = <Image src={FanTokens2} alt="FanTokens" className="Fan2 absolute bottom-[78%] left-[65%] w-[46px] blur-[1px] transition-all duration-300 tablet:bottom-[42%]  tablet:left-[20%] tablet:w-[86px] tablet:blur-0" />;
    t6 = <Image src={Gem} alt="Cristal" className="Cristal1 table:top-[15%] absolute left-[64%]  top-[8%] w-[148px] rotate-[-30deg] transition-all duration-300 tablet:left-[32%] tablet:w-[272px]" />;
    t7 = <Image src={Gem} alt="Cristal" className="Cristal2 absolute left-[3%] top-[-2%] w-[83px] rotate-[-40deg] blur-[0.5px] transition-all duration-300 tablet:top-[61%] tablet:w-[153px] tablet:blur-[2px]" />;
    t8 = <Image src={Gem} alt="Cristal" className="Cristal3  absolute  left-[14%] top-[18%]  w-[68px] blur-[0.5px] transition-all duration-300 tablet:left-[41.5%] tablet:top-[58.5%]  tablet:w-[97px] tablet:blur-[2px]" />;
    t9 = <Image src={Poe2} alt="Poe" className="Poe3 absolute left-[43%] top-[48%] hidden h-[172px] w-[172px] tablet:block " />;
    t10 = <Image src={Poe2} alt="Poe" className="Poe4 absolute  right-[14%] top-[-3%] h-[80px] w-[80px] blur-[1px] transition-all duration-300 tablet:right-[30%] tablet:top-[5%] tablet:blur-0" />;
    t11 = <Image src={FanTokens2} alt="FanTokens" className="Fan3 absolute right-[11%] w-[55px] transition-all duration-300 tablet:right-[33%] tablet:top-[5%]  tablet:w-[142px]" />;
    t12 = <Image src={Gem} alt="Cristal" className="Cristal4 absolute bottom-[10%]   right-[28.5%] hidden w-[148px] blur-[2px] tablet:block" />;
    $[0] = t10;
    $[1] = t11;
    $[2] = t12;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[0];
    t11 = $[1];
    t12 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t13;
  if ($[11] !== t1) {
    t13 = <div className={t1}>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[11] = t1;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  return t13;
};